import { useMemo } from 'react';
import type { UserSummaryDto } from '@inference.engine/workspace-api-client';
import { parseAnnotation, useComments } from '@/features/comment-on-file';
import type { Annotation } from '@/features/comment-on-file';

export interface VideoMarker {
  commentId: string;
  timecode: number;
  annotation: Annotation;
  versionId: string;
  author: UserSummaryDto;
}

// Top-level only: replies aren't eagerly fetched, and one query per parent
// would be too expensive just to derive marker dots.
export function useMarkers(): VideoMarker[] {
  const { comments } = useComments();

  return useMemo(() => {
    const markers: VideoMarker[] = [];
    for (const c of comments) {
      if (c.parentId) continue;
      if (c.deleted) continue;
      const ann = parseAnnotation(c.annotation);
      if (ann?.kind === 'video' && Number.isFinite(ann.timestamp)) {
        markers.push({
          commentId: c.id,
          timecode: ann.timestamp,
          annotation: ann,
          versionId: c.versionId ?? '',
          author: c.author,
        });
      }
    }
    return markers;
  }, [comments]);
}
